import React from 'react';
import {generalStore, modalStore, projectStore, procedureStore, dataStore, history} from '../../index';
import {DATA_INTERVAL} from '../../MobxStores/DataStore';
import {procedureTypeEnum} from '../../serverClientShared/sharedEnums';

const findConnectedProcedureNames = (projectId, procedureId) => {
    const proceduresMap = dataStore.projectsProceduresMap.get(projectId);
    if (!proceduresMap) return [];
    const names = [];
    for (const p of proceduresMap.values()) {
        if (p.ProcedureType !== procedureTypeEnum.FUSION && p.ThreeDModelsConnected?.includes(procedureId)) {
            names.push(p.ProcedureName);
        }
    }
    return names;
};

const renderBody = (procedure, connectedNames) => (
    <div>
        <div>
            {generalStore.translate('deleteProcedureConfirmSentence1_beforeName')}{' '}
            <span className="font-semibold">{procedure.ProcedureName}</span>{' '}
            {generalStore.translate('deleteProcedureConfirmSentence2_afterName')}
        </div>
        {connectedNames.length > 0 && (
            <ul className="list-disc list-inside ml-5 mt-2 space-y-1">
                {connectedNames.map((n, i) => <li key={i}>{n}</li>)}
            </ul>
        )}
    </div>
);

const removeFromProceduresMap = (procedure) => {
    const projectId = procedure.ProjectRef;
    const proceduresMap = dataStore.projectsProceduresMap.get(projectId);
    if (!proceduresMap) return;
    proceduresMap.delete(procedure.ProcedureIdentifier);
    dataStore.set('projectsProceduresMap', projectId, proceduresMap);
    dataStore.set('projectsProceduresExpirationMap', projectId, Date.now() + DATA_INTERVAL);
};

const reassignDefault3DModelIfNeeded = async (procedure) => {
    if (procedure.ProcedureIdentifier !== projectStore.currentProject?.Default3DModel) return;
    const proceduresMap = dataStore.projectsProceduresMap.get(procedure.ProjectRef);
    let next = null;
    for (const p of (proceduresMap?.values() || [])) {
        if (p.IsPublished && p.ProcedureType === procedureTypeEnum.FUSION) { next = p.ProcedureIdentifier; break; }
    }
    projectStore.currentProject.Default3DModel = next;
    await projectStore.updateProject({
        ProjectIdentifier: projectStore.currentProject.ProjectIdentifier,
        Default3DModel: next,
    });
};

const executeDelete = async (procedure, deletePath) => {
    const ok = await procedureStore.deleteProcedure(procedure);
    if (!ok) throw new Error('delete failed');
    removeFromProceduresMap(procedure);
    await reassignDefault3DModelIfNeeded(procedure);
    if (deletePath) history.push(deletePath);
    else await projectStore.refreshCurrentFolderLevel();
};

export const openDeleteProcedureConfirm = (procedure, deletePath) => {
    const projectId = projectStore.currentProject?.ProjectIdentifier;
    const connectedNames = procedure.ProcedureType === procedureTypeEnum.FUSION
        ? findConnectedProcedureNames(projectId, procedure.ProcedureIdentifier)
        : [];
    modalStore.modalData = {
        title: generalStore.translate('deleteItem'),
        bodyText: renderBody(procedure, connectedNames),
        confirmText: generalStore.translate('delete'),
        isDelete: true,
        confirmActions: () => modalStore.runAsync(
            executeDelete(procedure, deletePath),
            generalStore.translate('problemDeletingProcedure'),
            generalStore.translate('procedureDeleted'),
            generalStore.translate('deletingProcedure') + '...',
        ),
    };
    modalStore.isGeneralConfirmActionDialogOpen = true;
};
